import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import imgAddress from "../../public/address.png";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Fragment, useState } from "react";
import { useRouter } from "next/router";
import PageLayout from "../../components/layout/PageLayout";
import { staticPath } from "../../utils";
import { getFooterData } from "../../utils/apiHelpers";

const Seo = dynamic(() => import("../../components/seo/Seo"), {
  ssr: false,
});
const SubTitle = dynamic(() => import("../../components/title/SubTitle"), {
  ssr: false,
});

const addresses = [
  {
    id: 6,
    title: "İşNet Genel Müdürlük",
    detail:
      "İçmeler Mah. Piri Reis Cd. No: 62 Türkiye İş Bankası Tuzla Teknoloji ve Operasyon Merkezi D Blok Tuzla/İstanbul",
    phone: "0850 290 02 90",
    phone_tel: "+908502900290",
    fax: "0216 514 73 50",
    fax_tel: "+902165147350",
    free_phone: "0800 601 01 01",
    free_phone_tel: "+08006010101",
    url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3018.3917062945516!2d29.306778315669256!3d40.841323037630175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab644f254e5d3%3A0x34a2c1d2ed46c0e!2zxLDFn05ldCBHZW5lbCBNw7xkw7xybMO8aw!5e0!3m2!1str!2str!4v1536837802746?wmode=transparent?wmode=transparent",
    lang: "tr",
  },
  {
    id: 5,
    title: "İşNet Levent Bölge Müdürlüğü",
    detail: "Levent Mah. Meltem Sk. İş Kuleleri 2 No:10 Kat:12, 34330 Beşiktaş",
    phone: "0850 290 02 90",
    phone_tel: "+908502900290",
    fax: "0212 279 94 37 ",
    fax_tel: "+902122799437",
    url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.3746627629675!2d29.009978815416435!3d41.08265987929327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6f6268b4e11f72ab!2zxLDFn05ldCBMZXZlbnQgQsO2bGdlIE3DvGTDvHJsw7zEn8O8!5e0!3m2!1sen!2str!4v1545716647407?wmode=transparent?wmode=transparent",
    lang: "tr",
  },
  {
    id: 4,
    title: "İşNet Ankara Bölge Müdürlüğü",
    detail:
      "Söğütözü Mah. Türkiye İş Bankası Atom Binası, Anadolu Bulvarı 2185.Cadde 11.Sokak Kat:1 No:16/A06510 Söğütözü/Ankara",
    phone: "0312 266 66 96",
    phone_tel: "+903122666696",
    fax: "0216 514 73 50",
    fax_tel: "+902165147350",
    url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.448000237566!2d32.7621073156489!3d39.90898949428532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d348bacfad671d%3A0x6c6a9807346edbc6!2zxLDFn05ldCBBbmthcmEgT2Zpcw!5e0!3m2!1str!2str!4v1536232494013?wmode=transparent?wmode=transparent",
    lang: "tr",
  },
  {
    id: 3,
    title: "İşNet Head Office",
    detail:
      "İçmeler Mah. Piri Reis Cd. No: 62 Türkiye İş Bankası Tuzla Teknoloji ve Operasyon Merkezi D Blok Tuzla/İstanbul",
    phone: "0850 290 02 90",
    phone_tel: "+908502900290",
    fax: "0216 514 73 50",
    fax_tel: "+902165147350",
    free_phone: "0800 601 01 01",
    free_phone_tel: "+08006010101",
    url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3018.3917062945516!2d29.306778315669256!3d40.841323037630175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab644f254e5d3%3A0x34a2c1d2ed46c0e!2zxLDFn05ldCBHZW5lbCBNw7xkw7xybMO8aw!5e0!3m2!1str!2str!4v1536837802746?wmode=transparent?wmode=transparent",
    lang: "en",
  },
  {
    id: 2,
    title: "İşNet Levent Regional Office",
    detail: "Levent Mah. Meltem Sk. İş Kuleleri 2 No:10 Kat:12, 34330 Beşiktaş",
    phone: "0850 290 02 90",
    phone_tel: "+908502900290",
    fax: "0212 279 94 37 ",
    fax_tel: "+902122799437",
    url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.3746627629675!2d29.009978815416435!3d41.08265987929327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6f6268b4e11f72ab!2zxLDFn05ldCBMZXZlbnQgQsO2bGdlIE3DvGTDvHJsw7zEn8O8!5e0!3m2!1sen!2str!4v1545716647407?wmode=transparent?wmode=transparent",
    lang: "en",
  },
  {
    id: 1,
    title: "İşNet Ankara Regional Office",
    detail:
      "Söğütözü Mah. Türkiye İş Bankası Atom Binası, Anadolu Bulvarı 2185.Cadde 11.Sokak Kat:1 No:16/A06510 Söğütözü/Ankara",
    phone: "0312 266 66 96",
    phone_tel: "+903122666696",
    fax: "0216 514 73 50",
    fax_tel: "+902165147350",
    url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.448000237566!2d32.7621073156489!3d39.90898949428532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d348bacfad671d%3A0x6c6a9807346edbc6!2zxLDFn05ldCBBbmthcmEgT2Zpcw!5e0!3m2!1str!2str!4v1536232494013?wmode=transparent?wmode=transparent",
    lang: "en",
  },
];

function address(props) {
  const { navbar, footer, navbarData, navbarFooterData } = props;
  const { t } = useTranslation();
  const { locale, asPath } = useRouter();
  const [copyBtn, setCopyBtn] = useState("");

  const handleCopyAddress = (e, address) => {
    setCopyBtn(address.id);
    navigator.clipboard.writeText(address.detail);
    setTimeout(() => {
      setCopyBtn("");
    }, 3000);
  };

  const handleCopyPhone = (e, address) => {
    setCopyBtn(address.id);
    navigator.clipboard.writeText(address.phone_tel);
    setTimeout(() => {
      setCopyBtn("");
    }, 3000);
  };

  const handleCopyFax = (e, address) => {
    setCopyBtn(address.id);
    navigator.clipboard.writeText(address.fax_tel);
    setTimeout(() => {
      setCopyBtn("");
    }, 3000);
  };

  const handleCopyFreePhone = (e, address) => {
    setCopyBtn(address.id);
    navigator.clipboard.writeText(address.free_phone_tel);
    setTimeout(() => {
      setCopyBtn("");
    }, 3000);
  };
  return (
    <PageLayout
      navbarData={navbarData}
      navbar={navbar}
      footer={footer}
      navbarFooterData={navbarFooterData}
    >
      <Seo
        title="Adres | İşNet"
        keywords={t("home:address")}
        description="İşNet'in adres ve telefon bilgilerine ulaşmak için sayfamızı inceleyebilirsiniz. Ürünlerimiz hakkında detaylı bilgi için ürün başvuru formu doldurabilirsiniz."
        url={asPath}
      />
      <SubTitle
        TitleText={t("home:address")}
        pageName={t("home:address")}
        mainPageName={t("home:contact_us")}
      />
      <Container>
        <div
          style={{
            backgroundImage: `url(${imgAddress.src})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPositionX: "right",
          }}
        >
          <div className="address_div">
            <div className="address_detail">
              <p>{t("home:company_title")}</p>
              <p>
                İş Net Elektronik Bilgi Üretim Dağıtım Ticaret ve İletişim
                Hizmetleri AŞ
              </p>
            </div>
            <div className="address_detail">
              <p>{t("home:denetim")}</p>
              <p>{t("home:denetim_name")}</p>
            </div>
            <div className="address_detail">
              <p>{t("home:sicil_no")}</p> <p>506576</p>
            </div>
          </div>
          <Row>
            {addresses.map((address, idx) => (
              <Fragment key={idx}>
                {locale === address.lang ? (
                  <Col md={4} key={idx}>
                    <div className="address_item">
                      <div
                        className={`btns-copy ${
                          address.id === copyBtn ? " active" : ""
                        }`}
                      >
                        <Dropdown className="dropdown-copy">
                          <Dropdown.Toggle id="dropdown-basic">
                            <i className="icon-copy" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            {address.detail ? (
                              <Dropdown.Item
                                onClick={(e) => handleCopyAddress(e, address)}
                              >
                                <i className="icon-location" />
                                Adresi Kopyala
                              </Dropdown.Item>
                            ) : null}
                            {address.phone_tel ? (
                              <Dropdown.Item
                                onClick={(e) => handleCopyPhone(e, address)}
                              >
                                <i className="icon-phone" />
                                Telefon Numarasını Kopyala
                              </Dropdown.Item>
                            ) : null}
                            {address.fax_tel ? (
                              <Dropdown.Item
                                onClick={(e) => handleCopyFax(e, address)}
                              >
                                <i className="icon-fax" />
                                Fax Numarasını Kopyala
                              </Dropdown.Item>
                            ) : null}
                            {address.free_phone_tel ? (
                              <Dropdown.Item
                                onClick={(e) => handleCopyFreePhone(e, address)}
                              >
                                <i className="icon-microphone" />
                                Ücretsiz Hattı Kopyala
                              </Dropdown.Item>
                            ) : null}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      <div className="address_content">
                        <p className="address_title">{address.title}</p>
                        <p>{address.detail}</p>
                        <a
                          href={`tel:${address.phone_tel}`}
                          className="address_phone mb-0"
                        >
                          {address.phone}
                        </a>
                        {address.free_phone && (
                          <p className="mb-0 mt-0">
                            {t("home:free_phone_customer")}:
                            <a
                              href={`tel:${address.free_phone_tel} free_phone_tel`}
                            >
                              {" "}
                              {address.free_phone}
                            </a>
                          </p>
                        )}

                        <p>
                          {t("home:fax")}:
                          <a href={`tel:${address.fax_tel}`}> {address.fax}</a>
                        </p>
                      </div>
                      <div className="address_map">
                        <iframe src={address.url} width="100%" />
                      </div>
                    </div>
                  </Col>
                ) : null}
              </Fragment>
            ))}
          </Row>
        </div>
      </Container>
    </PageLayout>
  );
}

export async function getStaticPaths({ locales }) {
  const paths = locales.map((item) => ({
    params: { main: "iletisim" },
    locale: item,
  }));
  return {
    paths,
    fallback: false, // can also be true or 'blocking'
  };
}

export async function getStaticProps(context) {
  const [navbarData, navbarFooterData, footerData] = await Promise.all([
    fetch(`${process.env.ISNETURL}/menu`).then((res) => res.json()),
    fetch(`${process.env.ISNETURL}/menu/footermenu`).then((res) => res.json()),
    Promise.resolve(getFooterData()),
  ]);

  const navbarFilter =
    navbarData && navbarData?.filter((item) => item.isDeleted === false);

  let navbar, footer;
  if (navbarFilter || footerData) {
    const nav = staticPath(navbarFilter);
    navbar = nav;
    footer = footerData;
  }

  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["home"])),
      navbar,
      footer,
      navbarData,
      navbarFooterData,
    },
    revalidate: 10,
  };
}

export default address;
